import React, { useEffect, useState, useCallback } from 'react';
import { READ_ONLY_EVENT, READ_ONLY_ACCESS_MESSAGE } from '../../utils/supabaseErrors';
import './read-only-toast.scss';

/**
 * Global, app-level toast that appears when a write is blocked because the
 * current user is a read-only QA auditor. Triggered by notifyReadOnly() (or any
 * code dispatching READ_ONLY_EVENT). Mounted once in the app layout.
 */
const ReadOnlyToast: React.FC = () => {
  const [message, setMessage] = useState<string | null>(null);

  const dismiss = useCallback(() => setMessage(null), []);

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<string>).detail;
      setMessage(detail || READ_ONLY_ACCESS_MESSAGE);
    };
    window.addEventListener(READ_ONLY_EVENT, handler);
    return () => window.removeEventListener(READ_ONLY_EVENT, handler);
  }, []);

  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(() => setMessage(null), 5000);
    return () => clearTimeout(timer);
  }, [message]);

  if (!message) return null;

  return (
    <div className="read-only-toast" role="status" aria-live="polite">
      <span className="read-only-toast__icon" aria-hidden="true">🔒</span>
      <span className="read-only-toast__message">{message}</span>
      <button className="read-only-toast__close" onClick={dismiss} aria-label="Dismiss">
        ×
      </button>
    </div>
  );
};

export default ReadOnlyToast;
